module.exports = __webpack_public_path__ + "img/google_play.9db6e4f6.jpeg";